import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CreateRefundDto, RefundCheckDto } from '@core/models';
import { environment } from '@env/environment';
import { catchError, map, Observable, of } from 'rxjs';
import {WalletService} from '@core/services/wallet.service';

@Injectable()
export class RefundService {
  private readonly http = inject(HttpClient); 
  private readonly walletService = inject(WalletService);

  readonly MINIMUM_REFUND_AMOUNT = 300; // in cents

  checkRefund(): Observable<RefundCheckDto> {
    return this.http.get(`${environment.apiURL}/wallets/refund/verify`).pipe(
      map((response: any) => (response.data as RefundCheckDto))
    );
  }

  createRefund(refund: CreateRefundDto): Observable<any> {
    return this.http.post(`${environment.apiURL}/wallets/refund/bank`, refund).pipe(
      catchError(() => of(1))
    );
  }

  createCardRefund(): Observable<any> {
      return this.http.post(`${environment.apiURL}/wallets/refund/card`, null);

  }
}
